module.exports = __webpack_public_path__ + "static/media/ico-edit.e3c0fb54.svg";